import { CommonStyles } from '../CommonStyles';

export const projectExplorerStyles: React.CSSProperties = {
  borderColor: CommonStyles.Colors.Grey178,
  borderStyle: 'solid',
  borderWidth: CommonStyles.Sizes.LineWidth,
  height: '300px',
  position: 'relative',
};